import FactoryDecorators from '@/utils/factoryDecorators'
import Toast from 'antd-mobile/es/toast'
import { isInNative, polyfillForIOS } from './utils'

// 捕获异常
export const tryCatchIssJsBridgeCourier = FactoryDecorators(
  async (params, originMethod, scope) => {
    try {
    //   if (!isInNative()) {
    //     throw new Error('此功能请在闪送员端内使用')
    //     return
    //   }
      originMethod.apply(scope, params)
    } catch (err) {
      Toast.info('发生网络错误，请稍后再试～')
      console.log(err.message, 'err.messageerr.message')
    }
  }
)
// 注入回调
export const injectCallBack = FactoryDecorators(
  (methodParams, originMethod, scope, DecoratorsParams, methodName) => {
    try {
      window.IssJsBridgeCourier = polyfillForIOS(methodName)
      const firstMethodParams = methodParams[0] || {}
      const ctx: any = window.IssJsBridgeCourier
      if (!ctx) {
        Toast.fail('window.IssJsBridgeCourier 未注入')
        return
      }
      ctx[`${methodName}CallBack`] = {
        ...firstMethodParams
      }
      const JSBridgeParams = {
        onSuccess: `window.IssJsBridgeCourier.${methodName}CallBack.onSuccess`,
        onFail: `window.IssJsBridgeCourier.${methodName}CallBack.onFail`,
        onFinally: `window.IssJsBridgeCourier.${methodName}CallBack.onFinally`
      }
      if (firstMethodParams.params) {
        JSBridgeParams.params = firstMethodParams.params || {}
      }
      ctx[methodName](JSON.stringify(JSBridgeParams))
    } catch (err) {
      Toast.info('发生网络错误，请重试～')
      console.log(err)
    }
    originMethod.apply(scope, methodParams)
  }
)
